import types from './ActionTypes';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import postData from 'Utils/PostData';
import patchData from 'Utils/PatchData';
import deleteData from 'Utils/DeleteData';

// interface
import { IConceptData, IGroupConcept } from 'store/StateInterfaces';

// load req
export function loadConceptDataRequest(conceptId: number) {
    return dispatch => {
        const url = `/concept/api/concept/${conceptId}/get_concept_page_data/`;
        return fetch(url)
            .then(res => res.json())
            .then(res => {
                dispatch(loadConceptDataSuccess(conceptId, res));
            })
            .catch(err => {
                displayGlobalMessage('Concept Data Loading failed', 'error');
                throw (err);
            })
    }
}

export function loadConceptDataSuccess(conceptId: number, data: IConceptData) {
    return {
        type: types.LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS,
        conceptId,
        data
    }
}

// delete req

export function deleteConceptElementRequest(conceptId: number, typeStr: string, typeId: number, id: number) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptId}/delete_element/?format=json`;
        const data = { 'type': typeId, 'id': id }
        return postData(url, data)
            .then(res => {
                displayGlobalMessage('Element Deleted Successfully', 'success');
                dispatch(deleteConceptElementSuccess(conceptId, typeStr, id));
            })
            .catch(err => {
                displayGlobalMessage('Delete Element Failed!', 'error');
                throw (err)
            })
    }
}


export function deleteConceptElementSuccess(conceptId: number, type: string, id: number) {
    return {
        type: types.DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS,
        conceptId,
        elemType: type,
        id
    }
}


// add req
export function addConceptElementRequest(conceptId: number, type: string, formData: FormData) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptId}/add_${type}/?format=json`;
        return postData(url, formData, "FormData")
            .then(response => {
                displayGlobalMessage('Element Added Succesfully', 'success')
                dispatch(addConceptElementSuccess(conceptId, type, response));
            })
            .catch(error => {
                displayGlobalMessage('Element Adding Failed!', 'error')
                throw (error)
            });
    }
}

export function addConceptElementSuccess(conceptId: number, type: string, content) {
    return {
        type: types.ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS,
        elemType: type,
        conceptId,
        content
    }
}


// reorder req

export function reorderConceptElementRequest(conceptId: number, formData: FormData) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptId}/reorder/?format=json`;
        return patchData(url, formData, "FormData")
            .then(response => {
                displayGlobalMessage('Element Reordered Succesfully', 'success')
                dispatch(reorderConceptElementSuccess(conceptId, response));
            })
            .catch(error => {
                displayGlobalMessage('Element Reordering Failed!', 'error')
                throw (error);
            });
    }
}

export function reorderConceptElementSuccess(conceptId: number, playlist) {
    return {
        type: types.REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS,
        conceptId,
        playlist
    }
}



export function infoEditConceptElementRequest(conceptId: number, data) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptId}/?format=json`;
        return patchData(url, data)
            .then(response => {
                displayGlobalMessage('Element info Edited Succesfully', 'success')
                dispatch(infoEditConceptElementSuccess(conceptId, response));
            })
            .catch(error => {
                displayGlobalMessage('Element info Editing Failed!', 'error')
                throw (error);
            });
    }
}

export function infoEditConceptElementSuccess(conceptId: number, { title, description }) {
    return {
        type: types.INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS,
        conceptId,
        title,
        description
    }
}
